import { /* baseClient, */ authClient, API } from "../../utils/index";
import { uploadSingleFile } from "../files";

// Get all boats
export const getBoats = () => {
	return authClient().get(`${API}/boat`);
};

// Get boat by id
export const getBoatById = (id) => {
	return authClient().get(`${API}/boat/${id}`);
};

// Get boat by regatta
export const getBoatsByRegatta = (id) => {
	return authClient().get(`${API}/boat/regatta/${id}`);
};

// Delete boat
export const deleteBoat = (id) => {
	return authClient().delete(`${API}/boat/${id}`);
};

// Create boat
export const postBoat = async (boat, image) => {
	if (image) {
		const fileURL = await uploadSingleFile(image, "boats");
		boat.image = fileURL.data.fileURL;
	}
	return authClient().post(`${API}/boat`, boat);
};

// Update boat
export const updateBoat = async (id, boat, image) => {
	if (image) {
		const response = await uploadSingleFile(image, "boats");
		boat.image = response.data.fileURL;
	}
	return authClient().put(`${API}/boat/${id}`, boat);
};

export const getBoatsBySailor = (sailorId) => {
	return authClient().get(`${API}/boat/sailor/${sailorId}`);
}